import { makeObservable, observable } from 'mobx';

export interface IVisitStatusModel {
  visitStatusId: number;
  name: string;
}

export class VisitStatusModel implements IVisitStatusModel {
  @observable visitStatusId: number;
  @observable name: string;

  constructor(params: Partial<IVisitStatusModel> = {} as VisitStatusModel) {
    const { visitStatusId = 0, name = '' } = params;

    this.visitStatusId = visitStatusId;
    this.name = name;

    makeObservable(this);
  }
}
